
















import { defineComponent, ref } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "RejectParticipation",
  components: { BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const loading = ref(false);

    const onReject = () => {
      loading.value = true;
      emit("reject", () => {
        loading.value = false;
      });
    };

    return { loading, onReject };
  },
});
